"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function supportRef(node) {
  // Function component
  if (node.type && node.type.prototype && !node.type.prototype.render) {
    return false;
  }

  return true;
}

exports.supportRef = supportRef;


//////////////////
// WEBPACK FOOTER
// ./~/rc-resize-observer/lib/util.js
// module id = 1171
// module chunks = 0